import { toast } from "react-toastify"

import { Img } from "ui-kit/components-branded/index"

export function notificationCopyUrl() {
    toast.success(
        <div className="is-flex is-align-items-center">
            <Img className="copy-link-notification__emoji" src="staple.png" />
            Ссылка скопирована
        </div>
    )
}
